"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circle = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Circle = ({ colour = "currentcolor", size = 16, }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: true },
    react_1.default.createElement("circle", { cx: "8", cy: "8", r: size / 2, fill: colour, stroke: "#2c2c2c", strokeWidth: "1" })));
exports.Circle = Circle;
//# sourceMappingURL=Circle.js.map